import { isFuture, isWithinInterval } from 'date-fns'
import { Product } from '@/types/sanity.types'
import { STATUS } from '@/const'

export enum PRODUCT_TYPE {
  NORMAL = 'normal',
  ETERNEL = 'eternel',
  SAISONNIER = 'saisonnier',
  CHAMPION = 'champion',
}

export enum PRODUCT_COLOR_STATUS {
  DEFAULT = 'default',
  NEW = 'new',
  LEAVING_SOON = 'leaving_soon',
}

export type InstantiateProduct = Product & {
  dates: {
    start: Date | undefined
    end: Date | undefined
    teasing: Date | undefined
  }
  next_delivery_date: Date | undefined
  current_batch_date_end: Date | undefined
}

export function instianciateProduct(product: Product): InstantiateProduct {
  const p: InstantiateProduct = {
    ...product,
    dates: {
      start: product.dates?.start ? new Date(product.dates.start) : undefined,
      end: product.dates?.end ? new Date(product.dates.end) : undefined,
      teasing: product.dates?.teasing
        ? new Date(product.dates.teasing)
        : undefined,
    },
    next_delivery_date: product.next_delivery_date
      ? new Date(product.next_delivery_date)
      : undefined,
    current_batch_date_end: product.current_batch_date_end
      ? new Date(product.current_batch_date_end)
      : undefined,
  } as InstantiateProduct

  return p
}

export function isProductSaleable(product: Product) {
  return (
    product.status === STATUS.PRECOMMANDE || product.status === STATUS.STOCK
  )
}

export function isProductOpenForSale(product: InstantiateProduct) {
  if (!product.dates.start || !product.dates.end) {
    return false
  }

  const now = new Date()

  return isWithinInterval(now, {
    start: product.dates.start,
    end: product.dates.end,
  })
}

export function isProductWillSoonBeForSale(product: InstantiateProduct) {
  if (!product.dates.start) {
    return false
  }

  return isFuture(product.dates.start)
}
